import React, { useState } from "react";
import "../../assests/css/CarForsale.css";

function CarsForSale() {
  // =========================
  // Search States
  // =========================

  const [search, setSearch] = useState("");
  const [make, setMake] = useState("");
  const [price, setPrice] = useState("");
  const [year, setYear] = useState("");
  const [fuel, setFuel] = useState("");

  // =========================
  // Vehicle Data
  // =========================

  const vehicles = [
    {
      id: 1,
      name: "Toyota Camry",
      make: "Toyota",
      year: 2023,
      price: 85000,
      fuel: "Petrol",
      image: "/images/camry.jpg",
    },
    {
      id: 2,
      name: "Nissan Patrol",
      make: "Nissan",
      year: 2022,
      price: 145000,
      fuel: "Petrol",
      image: "/images/patrol.jpg",
    },
    {
      id: 3,
      name: "Toyota Land Cruiser",
      make: "Toyota",
      year: 2024,
      price: 185000,
      fuel: "Petrol",
      image: "/images/landcruiser.jpg",
    },
    {
      id: 4,
      name: "Honda Accord",
      make: "Honda",
      year: 2023,
      price: 95000,
      fuel: "Petrol",
      image: "/images/accord.jpg",
    },
    {
      id: 5,
      name: "Hyundai Tucson",
      make: "Hyundai",
      year: 2024,
      price: 105000,
      fuel: "Petrol",
      image: "/images/tucson.jpg",
    },
    {
      id: 6,
      name: "Kia Sportage",
      make: "Kia",
      year: 2023,
      price: 98000,
      fuel: "Petrol",
      image: "/images/sportage.jpg",
    },
    {
      id: 7,
      name: "Toyota RAV4",
      make: "Toyota",
      year: 2024,
      price: 110000,
      fuel: "Hybrid",
      image: "/images/rav4.jpg",
    },
    {
      id: 8,
      name: "Nissan X-Trail",
      make: "Nissan",
      year: 2023,
      price: 92000,
      fuel: "Petrol",
      image: "/images/xtrail.jpg",
    },
    {
      id: 9,
      name: "Toyota Fortuner",
      make: "Toyota",
      year: 2022,
      price: 125000,
      fuel: "Diesel",
      image: "/images/fortuner.jpg",
    },
    {
      id: 10,
      name: "Hyundai Santa Fe",
      make: "Hyundai",
      year: 2024,
      price: 135000,
      fuel: "Petrol",
      image: "/images/santafe.jpg",
    },
    {
      id: 11,
      name: "Kia Sorento",
      make: "Kia",
      year: 2023,
      price: 128000,
      fuel: "Petrol",
      image: "/images/sorento.jpg",
    },
    {
      id: 12,
      name: "Nissan Sunny",
      make: "Nissan",
      year: 2024,
      price: 55000,
      fuel: "Petrol",
      image: "/images/sunny.jpg",
    },
  ];

  // =========================
  // Filter Vehicles
  // =========================

  const filteredVehicles = vehicles.filter((vehicle) => {
    const searchText = search.toLowerCase().trim();

    const searchMatch =
      searchText === "" ||
      vehicle.name.toLowerCase().includes(searchText) ||
      vehicle.make.toLowerCase().includes(searchText);

    const makeMatch =
      make === "" || vehicle.make === make;

    const priceMatch =
      price === "" || vehicle.price <= Number(price);

    const yearMatch =
      year === "" || vehicle.year >= Number(year);

    const fuelMatch =
      fuel === "" || vehicle.fuel === fuel;

    return (
      searchMatch &&
      makeMatch &&
      priceMatch &&
      yearMatch &&
      fuelMatch
    );
  });

  // =========================
  // Clear Filters
  // =========================

  const clearFilters = () => {
    setSearch("");
    setMake("");
    setPrice("");
    setYear("");
    setFuel("");
  };

  // =========================
  // View Vehicle
  // =========================

  const viewVehicle = (vehicle) => {
    alert(
      `Vehicle: ${vehicle.name}\n\n` +
      `Make: ${vehicle.make}\n` +
      `Year: ${vehicle.year}\n` +
      `Fuel: ${vehicle.fuel}\n` +
      `Price: QAR ${vehicle.price.toLocaleString()}`
    );
  };

  return (
    <div className="cars-for-sale-page">

      {/* =====================================
          PAGE HEADER
      ====================================== */}

      <section className="cars-sale-header">
        <div className="container">

          <h1>Cars for Sale</h1>

          <p>
            Find your perfect vehicle from our latest cars available for sale.
          </p>

        </div>
      </section>


      {/* =====================================
          SEARCH SECTION
      ====================================== */}

      <section className="vehicle-search-section">

        <div className="container">

          <div className="vehicle-search-box">

            <div className="search-title">

              <h2>
                Search Vehicles
              </h2>

              <p>
                Find the right car for you
              </p>

            </div>


            <div className="row g-3">

              {/* Search Vehicle */}

              <div className="col-lg-4 col-md-6">

                <label>
                  Search Vehicle
                </label>

                <div className="input-group">

                  <span className="input-group-text">
                    🔍
                  </span>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search car name..."
                    value={search}
                    onChange={(e) =>
                      setSearch(e.target.value)
                    }
                  />

                </div>

              </div>


              {/* Make */}

              <div className="col-lg-2 col-md-6">

                <label>
                  Make
                </label>

                <select
                  className="form-select"
                  value={make}
                  onChange={(e) =>
                    setMake(e.target.value)
                  }
                >

                  <option value="">
                    All Makes
                  </option>

                  <option value="Toyota">
                    Toyota
                  </option>

                  <option value="Nissan">
                    Nissan
                  </option>

                  <option value="Honda">
                    Honda
                  </option>

                  <option value="Hyundai">
                    Hyundai
                  </option>

                  <option value="Kia">
                    Kia
                  </option>

                </select>

              </div>


              {/* Price */}

              <div className="col-lg-2 col-md-6">

                <label>
                  Max Price
                </label>

                <select
                  className="form-select"
                  value={price}
                  onChange={(e) =>
                    setPrice(e.target.value)
                  }
                >

                  <option value="">
                    Any Price
                  </option>

                  <option value="50000">
                    QAR 50,000
                  </option>

                  <option value="75000">
                    QAR 75,000
                  </option>

                  <option value="100000">
                    QAR 100,000
                  </option>

                  <option value="125000">
                    QAR 125,000
                  </option>

                  <option value="150000">
                    QAR 150,000
                  </option>

                  <option value="200000">
                    QAR 200,000
                  </option>

                </select>

              </div>


              {/* Year */}

              <div className="col-lg-2 col-md-6">

                <label>
                  Year From
                </label>

                <select
                  className="form-select"
                  value={year}
                  onChange={(e) =>
                    setYear(e.target.value)
                  }
                >

                  <option value="">
                    Any Year
                  </option>

                  <option value="2025">
                    2025
                  </option>

                  <option value="2024">
                    2024
                  </option>

                  <option value="2023">
                    2023
                  </option>

                  <option value="2022">
                    2022
                  </option>

                  <option value="2021">
                    2021
                  </option>

                </select>

              </div>


              {/* Fuel */}

              <div className="col-lg-2 col-md-6">

                <label>
                  Fuel Type
                </label>

                <select
                  className="form-select"
                  value={fuel}
                  onChange={(e) =>
                    setFuel(e.target.value)
                  }
                >

                  <option value="">
                    All Fuel
                  </option>

                  <option value="Petrol">
                    Petrol
                  </option>

                  <option value="Diesel">
                    Diesel
                  </option>

                  <option value="Hybrid">
                    Hybrid
                  </option>

                  <option value="Electric">
                    Electric
                  </option>

                </select>

              </div>

            </div>


            {/* Search Buttons */}

            <div className="search-buttons">

              <button
                type="button"
                className="btn btn-primary"
              >
                🔍 Search Vehicles
              </button>

              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={clearFilters}
              >
                Clear Filters
              </button>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================
          VEHICLE RESULTS
      ====================================== */}

      <section className="vehicle-results">

        <div className="container">

          {/* Results Header */}

          <div className="results-header">

            <div>

              <h2>
                Available Vehicles
              </h2>

              <p>
                Browse our latest vehicles for sale
              </p>

            </div>

            <span>
              {filteredVehicles.length} Vehicles Found
            </span>

          </div>


          {/* =================================
              VEHICLE GRID
              4 COLUMNS
          ================================== */}

          <div className="row g-4">

            {filteredVehicles.length > 0 ? (

              filteredVehicles.map((vehicle) => (

                <div
                  className="col-lg-3 col-md-4 col-sm-6 col-12"
                  key={vehicle.id}
                >

                  <div className="vehicle-card">

                    {/* Vehicle Image */}

                    <div className="vehicle-image">

                      <img
                        src={vehicle.image}
                        alt={vehicle.name}
                        onError={(e) => {
                          e.target.src =
                            "https://via.placeholder.com/600x400?text=Vehicle";
                        }}
                      />

                    </div>


                    {/* Vehicle Content */}

                    <div className="vehicle-content">

                      <h3>
                        {vehicle.name}
                      </h3>


                      <div className="vehicle-details">

                        <span>
                          📅 {vehicle.year}
                        </span>

                        <span>
                          ⛽ {vehicle.fuel}
                        </span>

                      </div>


                      <div className="vehicle-price">

                        QAR{" "}
                        {vehicle.price.toLocaleString()}

                      </div>


                      <button
                        type="button"
                        className="view-vehicle-btn"
                        onClick={() =>
                          viewVehicle(vehicle)
                        }
                      >
                        View Vehicle
                      </button>

                    </div>

                  </div>

                </div>

              ))

            ) : (

              <div className="no-results">

                <div className="no-results-icon">
                  🔍
                </div>

                <h3>
                  No vehicles found
                </h3>

                <p>
                  Try changing your search filters.
                </p>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={clearFilters}
                >
                  Reset Search
                </button>

              </div>

            )}

          </div>

        </div>

      </section>

    </div>
  );
}

export default CarsForSale;